import raf from 'raf';

export const easing = {
  easeOut: progress => progress * (2 - progress),
};

export function tween({
  from = 0,
  to = 1,
  duration = 200,
  easingFunction = easing.easeOut,
  // eslint-disable-next-line no-unused-vars
  onUpdate = _ => {},
  onComplete = () => {},
} = {}) {
  let startTime;

  function update(time) {
    const progress =
      duration === 0
        ? 1
        : Math.min(Math.max(0, (time - startTime) / duration), 1);
    const value = from + (to - from) * easingFunction(progress);

    onUpdate(value);

    return progress < 1;
  }

  function animate(time) {
    if (startTime === undefined) {
      // Estimate start time to one frame ago (at 60 fps). We do it this way to get decently accurate timing without
      // having to mess with performance.now() compatibility.
      startTime = time - 1000 / 60;
    }

    const rafHandle = raf(animate);
    const result = update(time);

    // If animation has finished, cancel it/unregister handle.
    if (!result) {
      raf.cancel(rafHandle);
      onComplete();
    }
  }

  raf(animate);
}
